/* eslint-disable max-statements */
import React, { useState, useEffect } from "react";
import styles from "./styles.css";

import PropTypes from "prop-types";
import QualityPromiseInfoSection from "./quality-promise-info-section";
import QualityPromiseContent from "./quality-promise-content";
import InspectionReportPopup from "../quality-promise-inspection-report-modal";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";

const QualityPromiseRevamp = ({
    content,
    inspectionReportData = {},
    config,
    fetchInspectionReportDataConnect,
    warrantyPlanInfo = {}
}) => {
    const {buyWithConfidence = [], appointmentId} = content;
    const [showInspectionReportModal, setShowInspectionReportModal] = useState(false);
    const [selectedInspectionCategoryData, setSelectedInspectionCategoryData] = useState([]);

    const { extendedWarranty = {}} = warrantyPlanInfo || {};

    const plans = extendedWarranty && extendedWarranty.plans || [];

    const handleReportClick = async(option) => {
        setSelectedInspectionCategoryData(option);
        setShowInspectionReportModal(!showInspectionReportModal);
        await yieldToMain();
    };

    const handleReportClose = () => {
        setShowInspectionReportModal(false);
    };
    useEffect(() => {
        if (appointmentId) {
            fetchInspectionReportDataConnect(appointmentId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appointmentId]);
    return (
        <div styleName={"styles.outer"}>
            <QualityPromiseInfoSection content ={content} />
            <QualityPromiseContent
                onClick={handleReportClick}
                inspectionReportData={inspectionReportData || {}}
                buyWithConfidence={buyWithConfidence}
                config={config}
                plans={plans}
            />
            {showInspectionReportModal && <InspectionReportPopup
                onClose={handleReportClose}
                inspectionReportData={inspectionReportData || {}}
                selectedInspectionCategoryData={selectedInspectionCategoryData} />}
        </div>
    );
};

QualityPromiseRevamp.propTypes = {
    content: PropTypes.array,
    inspectionReportData: PropTypes.bool,
    config: PropTypes.object,
    fetchInspectionReportDataConnect: PropTypes.object,
    warrantyPlanInfo: PropTypes.object
};

export default QualityPromiseRevamp;
